/** @format */

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FallbackSeoUrlService {
  /**
   * Build a product's base SEO URL from its title and ecode, mirroring the logic used by the product catalog to
   * minimize the likelihood of the URL being incorrect & the product catalog API triggering a redirect on the linked
   * PDP page.
   * @see {@link https://github.com/dsg-tech/search-admin/blob/25a2a23/shared/foundation-core/src/main/java/com/dsg/foundation/util/SEOUtil.java|SEOUtil logic}
   * @see {@link https://github.com/dsg-tech/search-admin/blob/2d0ae36/shared/foundation-core/src/main/resources/seo-url-config.yml|String replacement config}
   */
  buildSeoUrl(title: string, ecode: string): string {
    const encodedKeyword = encodeURIComponent(
      `${title}-${ecode}`
        .replaceAll(/\s?[.]\s?/g, '') // seo-url-config lines 4:5
        .replaceAll(/[\s\-+&/\u2013\u2014]+/g, '-')
        .replaceAll(/[^a-zA-Z0-9-]/g, '')
        .replaceAll(/-+/g, '-'),
    );
    // Keyword part of the URL is case-sensitive and will trigger a redirect if not all-lowercase
    return `/p/${encodedKeyword}/${ecode}`.toLowerCase();
  }
}
